<mat-toolbar color="primary">
  <img src="assets/Logos/HyLogoPng.png" alt="Logo" class="logo-img" />

  <span class="spacer"></span>

  <div class="nav-links desktop-only">
    <a mat-button routerLink="inicio">Inicio</a>
    <a mat-button routerLink="productos">Productos</a>
    <a mat-button routerLink="articulospromocionales">Artículos Promocionales</a>
    <a mat-button routerLink="nosotros">Nosotros</a>
  </div>

  <div class="mobile-only">
    <button mat-icon-button [matMenuTriggerFor]="menu" (click)="onMenuClick()">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button mat-menu-item routerLink="inicio">Inicio</button>
      <button mat-menu-item routerLink="productos">Productos</button>
      <button mat-menu-item routerLink="articulospromocionales">Artículos Promocionales</button>
      <button mat-menu-item routerLink="nosotros">Nosotros</button>
    </mat-menu>
  </div>
</mat-toolbar>

<main>
  <router-outlet></router-outlet>
</main>

<footer style="text-align: center; padding: 12px; background: #afadad;">
  © 2025 H&L tienda en línea. Todos los derechos reservados.
</footer>
